import { useState, useCallback } from "react";

let _resolve = null;

export function useConfirm() {
  const [state, setState] = useState({ open:false, message:"", detail:"" });

  const confirm = useCallback((message, detail="") => {
    setState({ open:true, message, detail });
    return new Promise(res => { _resolve = res; });
  }, []);

  const onOk     = () => { setState(s=>({...s,open:false})); _resolve&&_resolve(true); };
  const onCancel = () => { setState(s=>({...s,open:false})); _resolve&&_resolve(false); };

  const Dialog = () => !state.open ? null : (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.35)",backdropFilter:"blur(4px)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center"}}
      onClick={onCancel}>
      <div onClick={e=>e.stopPropagation()}
        style={{background:"#fff",borderRadius:16,padding:"28px 28px 20px",width:360,boxShadow:"0 24px 64px rgba(0,0,0,0.18)",animation:"nx-modal-open 0.25s cubic-bezier(0.16,1,0.3,1) both"}}>
        <div style={{fontSize:17,fontWeight:800,color:"#0f1428",marginBottom:8}}>⚠️ Confirmation</div>
        <div style={{fontSize:14,color:"#334155",lineHeight:1.6,marginBottom:state.detail?8:20}}>{state.message}</div>
        {state.detail&&<div style={{fontSize:12,color:"#94a3b8",marginBottom:20}}>{state.detail}</div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button onClick={onCancel}
            style={{padding:"9px 20px",borderRadius:9,border:"1px solid #e2e8f0",background:"transparent",color:"#64748b",fontSize:13,fontWeight:600,cursor:"pointer"}}>
            Annuler
          </button>
          <button onClick={onOk}
            style={{padding:"9px 20px",borderRadius:9,border:"none",background:"linear-gradient(135deg,#ef4444,#dc2626)",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer",boxShadow:"0 2px 8px rgba(239,68,68,0.3)"}}>
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );

  return { confirm, Dialog };
}
